import React, { useState, useContext } from 'react'
import {
  Alerts,
  ButtonLoading,
  HeaderPage,
  InputPesquisa,
  InputText,
  InstaBtt,
  Loading,
  SearchAlert,
  SelectInput,
} from '../../Simple'
import { CardHeader, Modal, Typography, Box, Grid, Link } from '@mui/material'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { AuthContext } from '../../../contexts/AuthContext'
import RouterHook from '../../../contexts/RouterHook'
import { FormatPhone } from '../../../utils'
import { Services } from '../../../services'
import { BiX } from 'react-icons/bi'

import './stylesLocation.css'
import { returnMaxLength } from '../../../utils/formatPhone'

export default function ModalLocation({ show, onClose }) {
  const { sttAuthCtx, actionsAuth } = useContext(AuthContext)
  const { userUCtx, actionsUCtx } = useContext(UsuarioContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)

  const serverRouter = RouterHook()

  const listRef = React.useRef(null)
  const [sttMd, setSttMd] = useState({
    modeModal: 'usuario', // usuario, location
    cidadesBuffer: [],
    autoLocation: null,
    cidadeSel: null,
    estados: [],
    cidades: [],
  })
  const [filterCidade, setFilterCidade] = useState('')

  const [userInfo, setUserInfo] = useState({
    name: userUCtx.usuario?.nome || '',
    pais: '+55',
    phone: userUCtx.usuario?.atleta.telefone || '',
    genero: userUCtx.usuario?.atleta.sexo || '0',
    nasc: userUCtx.usuario?.atleta.nascimento
      ? Services.DataFormat('DD/MM/YYYY', userUCtx.usuario.atleta.nascimento)
      : '',
  })

  const [loading, setLoading] = useState(true)

  React.useEffect(() => {
    // Verifica se usuário tem telefone e data de nascimento
    if (
      sttAuthCtx.isLogged &&
      (!userUCtx.usuario.atleta?.telefone || !userUCtx.usuario.atleta?.nascimento)
    ) {
      setLoading(false)
    } else {
      setSttMd(prevState => ({
        ...prevState,
        modeModal: 'location',
      }))
      BuscarCidadesAtivas()
    }
  }, [])

  async function BuscarCidadesAtivas() {
    setLoading(true)
    const reqs = await actionsAuth.BuscarCidadesAtivas()
    //console.log('reqs', reqs)
    if (reqs.retorno) {
      const estados = []
      reqs.registro.forEach(cid => {
        if (!estados.length) {
          estados.push(cid.estado)
        } else {
          const find = estados.find(est => est.idestado === cid.estado.idestado)
          if (!find) estados.push(cid.estado)
        }
      })
      reqs.registro.forEach(cid => {
        cid.label = `${cid.nomeCidade} - ${cid.estado.sigla}`
      })

      // const autoLocation = await BuscarAtualLocationUser()

      setSttMd(prevState => ({
        ...prevState,
        estados: estados,
        cidades: reqs.registro.slice(0, 30),
        cidadesBuffer: reqs.registro,
        // autoLocation,
      }))
    }
    setLoading(false)
  }

  // async function BuscarAtualLocationUser() {
  //   try {
  //     const response = await fetch('https://ipapi.co/json/')
  //     const data = await response.json()
  //     return {
  //       city: data.city,
  //       region: data.region,
  //       region_code: data.region_code,
  //       country: data.country_name,
  //       label: data.city,
  //     }
  //   } catch (error) {
  //     return null
  //   }
  // }

  async function AtualizarCidadeUser(city) {
    setLoading(true)
    actionsCtxEmps.handleLoads('empresas', true)
    if (sttAuthCtx.isLogged) {
      const user = {
        ...userUCtx.usuario,
        cidade: city.nomeCidade,
        estado: city.estado.nomeEstado,
      }
      const reqs = await actionsUCtx.AtualizarUsuario(user)
      if (reqs.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possível atualizar sua cidade. Por favor, verifique sua conexão com a internet e tente novamente.',
        )
      }
    }

    //console.log('Usuario Atualizado', user)
    actionsCtxEmps.handleSttPg('updateEmpresa', !sttPg.updateEmpresa)
    const label = Services.ReturnLabelURL(city.estado.nomeEstado, city.nomeCidade)
    // console.log('label', label)
    serverRouter('home', label)
    setLoading(false)
    onClose()
  }

  async function actionConfirmeDados() {
    setLoading('atualizando-dados')

    const atleta = {
      ...userUCtx.usuario.atleta,
      nascimento: userInfo.nasc,
      telefone: userInfo.phone,
      sexo: userInfo.genero,
    }

    const user = {
      ...userUCtx.usuario,
      nome: userInfo.name,
      genero: userInfo.genero,
      atleta,
    }
    const req = await actionsUCtx.AtualizarUsuario(user)
    if (req.retorno) {
      setSttMd(prevState => ({
        ...prevState,
        modeModal: 'location',
      }))
      await BuscarCidadesAtivas()
    }

    if (loading) setLoading(false)
  }

  function ReturnLabelLoading() {
    // loading === 'atualizando' ? 'Atualizando sua cidade' : 'Carregando cidades...'
    // if (!userUCtx.usuario.atleta.nascimento || !userUCtx.usuario.atleta.telefone) {
    //   return 'Completando seus dados'
    // } else
    if (loading === 'atualizando') {
      return 'Atualizando sua cidade'
    } else {
      return 'Carregando cidades...'
    }
  }

  function ClosedModal() {
    if (
      sttAuthCtx.isLogged &&
      (!userUCtx.usuario.atleta?.telefone || !userUCtx.usuario.atleta?.nascimento)
    ) {
      Alerts.swal('warning', 'Aviso', 'Você precisa completar seu cadastro para continuar.')
      return false
    } else if (sttAuthCtx.isLogged && !userUCtx.usuario.cidade) {
      Alerts.swal('warning', 'Aviso', 'Você precisa escolher uma cidade para continuar.')
      return false
    }
    onClose()
  }

  function ValidarDados() {
    const nomeValido = userInfo.name.split(' ').filter(n => n.length > 1).length >= 2
    const telefone = userInfo.phone.replace(/\D/g, '')
    const telefoneValido = telefone.length > 5 && telefone.length <= returnMaxLength(userInfo.pais)
    const dataNascimentoValida = /^\d{2}\/\d{2}\/\d{4}$/.test(userInfo.nasc)

    return !(nomeValido && telefoneValido && dataNascimentoValida)
  }

  React.useEffect(() => {
    const handleBack = event => {
      event.preventDefault()
      ClosedModal()
    }
    window.history.pushState(null, '', window.location.href)
    window.addEventListener('popstate', handleBack)
    return () => {
      window.removeEventListener('popstate', handleBack)
    }
  }, [sttMd.modeModal])

  let flagRef = React.useRef(false)
  React.useEffect(() => {
    const handleScroll = () => {
      if (
        listRef.current &&
        listRef.current.scrollTop + listRef.current.clientHeight >=
          listRef.current.scrollHeight - 10
      ) {
        if (!flagRef.current) {
          flagRef.current = true
          const cidades = sttMd.cidadesBuffer.slice(sttMd.cidades.length, sttMd.cidades.length + 30)
          setSttMd(prevState => ({
            ...prevState,
            cidades: [...prevState.cidades, ...cidades],
          }))
          flagRef.current = false
        }
      }
    }
    const currentRef = listRef.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll)
      }
    }
  }, [sttMd.cidades, sttMd.cidadesBuffer])

  React.useEffect(() => {
    if (filterCidade) {
      const filterNormalized = filterCidade
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
      const cidades = sttMd.cidadesBuffer
        .filter(cidade =>
          cidade.label
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .includes(filterNormalized),
        )
        .slice(0, 30)

      setSttMd(prevState => ({
        ...prevState,
        cidades: cidades,
      }))
    } else {
      setSttMd(prevState => ({
        ...prevState,
        cidades: sttMd.cidadesBuffer.slice(0, 30),
      }))
    }
  }, [filterCidade])

  return (
    <Modal
      open={show}
      onClose={ClosedModal}
      className='contain-overlay-location'
      disableEnforceFocus
    >
      <div
        className={
          sttMd.modeModal === 'location'
            ? 'contain-content-location'
            : 'contain-content-updated-user'
        }
      >
        <>
          {loading === true ? (
            <div className='contain-loading'>
              <Loading text={ReturnLabelLoading()} />
            </div>
          ) : sttMd.modeModal === 'location' ? (
            <>
              <CardHeader
                sx={stModal.containHeader}
                avatar={
                  sttAuthCtx.isMobile ? (
                    <ArrowBackIosIcon
                      onClick={ClosedModal}
                      sx={{ width: '30px', height: '30px', color: 'var(--color-text-hig)' }}
                    />
                  ) : (
                    <></>
                  )
                }
                title={
                  <Typography variant='h6' sx={stModal.titleModal}>
                    De onde você é?
                  </Typography>
                }
                subheader={
                  <Typography variant='body1' sx={stModal.subTitle}>
                    {sttMd.cidadesBuffer.length
                      ? `Já estamos em mais de ${sttMd.cidadesBuffer.length - 4} cidades`
                      : ``}
                  </Typography>
                }
                action={
                  sttAuthCtx.isMobile ? (
                    <></>
                  ) : (
                    <BiX
                      onClick={ClosedModal}
                      style={{
                        cursor: 'pointer',
                        color: 'var(--color-text-hig)',
                        fontSize: '30px',
                      }}
                    />
                  )
                }
              />
              <InputPesquisa
                width='calc(100% - 20px)'
                textPlace='Pesquisar por Cidade'
                input={filterCidade}
                onChange={e => setFilterCidade(e.target.value)}
              />
              <div className='tw-mt-2 tw-w-full' />
              <div ref={listRef} className='contain-list-cidades'>
                {sttMd.cidades.length ? (
                  sttMd.cidades.map((cidade, index) => (
                    <React.Fragment key={index}>
                      <CompCidade city={cidade} />
                    </React.Fragment>
                  ))
                ) : (
                  <div className='contain-loading' style={{ flexDirection: 'column' }}>
                    <SearchAlert text={'Nenhuma cidade encontrada'} />
                  </div>
                )}
              </div>
              <InstaBtt />
            </>
          ) : (
            <Box sx={{ height: '100%' }}>
              {sttAuthCtx.isMobile ? (
                <HeaderPage
                  title='Quase pronto'
                  subTitle='Insira seus dados pessoais para continuar...'
                  // action={() => {
                  //   actionsAuth.authStep('login')
                  // }}
                />
              ) : (
                <CardHeader
                  sx={stModal.containHeader}
                  avatar={
                    sttAuthCtx.isMobile ? (
                      <ArrowBackIosIcon
                        onClick={ClosedModal}
                        sx={{ width: '30px', height: '30px', color: 'var(--color-text-hig)' }}
                      />
                    ) : (
                      <></>
                    )
                  }
                  title={
                    <Typography variant='h6' sx={stModal.titleModal}>
                      Quase pronto
                    </Typography>
                  }
                  subheader={
                    <Typography variant='body1' sx={stModal.subTitle}>
                      Insira seus dados pessoais para continuar...
                    </Typography>
                  }
                  action={
                    sttAuthCtx.isMobile ? (
                      <></>
                    ) : (
                      <BiX
                        onClick={ClosedModal}
                        style={{
                          cursor: 'pointer',
                          color: 'var(--color-text-hig)',
                          fontSize: '30px',
                        }}
                      />
                    )
                  }
                />
              )}
              <Grid container spacing={2} sx={{ px: 2 }}>
                <Grid item xs={12}>
                  <InputText
                    type='text'
                    label='Nome Completo*'
                    value={userInfo.name}
                    onKeyDown={e => {
                      if (e.key === 'Enter' && !sttAuthCtx.isMobile) {
                        e.preventDefault()
                        actionConfirmeDados()
                      }
                    }}
                    onChange={e => {
                      setUserInfo(prevState => ({ ...prevState, name: e.target.value }))
                    }}
                  />
                </Grid>

                <Grid item xs={4}>
                  <SelectInput
                    label='País'
                    value={userInfo.pais}
                    onChange={e => {
                      setUserInfo(prevState => ({ ...prevState, pais: e.target.value, phone: '' }))
                    }}
                    options={[
                      { value: '+55', label: '🇧🇷 (+55)' },
                      { value: '+54', label: '🇦🇷 (+54)' },
                      { value: '+598', label: '🇺🇾 (+598)' },
                      { value: '+595', label: '🇵🇾 (+595)' },
                      { value: '+591', label: '🇧🇴 (+591)' },
                      { value: '+51', label: '🇵🇪 (+51)' },
                      { value: '+57', label: '🇨🇴 (+57)' },
                      { value: '+58', label: '🇻🇪 (+58)' },
                    ]}
                  />
                </Grid>
                <Grid item xs={8}>
                  <InputText
                    type='tel'
                    label='Telefone*'
                    value={userInfo.phone}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        actionConfirmeDados()
                      }
                    }}
                    onChange={e => {
                      setUserInfo(prev => ({
                        ...prev,
                        phone:
                          prev.pais === '+55'
                            ? FormatPhone(e.target.value, userInfo.pais)
                            : e.target.value.replace(/\D/g, '').slice(0, 15),
                      }))
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <SelectInput
                    label='Gênero'
                    value={userInfo.genero}
                    onChange={e => {
                      setUserInfo(prevState => ({ ...prevState, genero: e.target.value }))
                    }}
                    options={[
                      { value: '0', label: 'Não informar' },
                      { value: 'Masculino', label: 'Masculino' },
                      { value: 'Feminino', label: 'Feminino' },
                      { value: 'Outro', label: 'Outro' },
                    ]}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InputText
                    type='tel'
                    value={userInfo.nasc}
                    label='Data de Nascimento*'
                    placeholder='DD/MM/YYYY'
                    onChange={e => {
                      const vs = Services.DataFormat('input-nascimento', e.target.value)
                      // Verifica se a data é antes de 2013
                      if (vs.length < 10) {
                        setUserInfo(prevState => ({ ...prevState, nasc: vs }))
                      } else if (
                        vs.length === 10 &&
                        Services.DataFormat('input-nascimento', e.target.value).split('/')[2] < 2009
                      ) {
                        setUserInfo(prevState => ({ ...prevState, nasc: vs }))
                      } else {
                        Alerts.swal(
                          'warning',
                          'Data de nascimento inválida',
                          'A idade mínima para cadastro é de 12 anos',
                        )
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ButtonLoading
                    disabled={ValidarDados()}
                    onClick={() => {
                      actionConfirmeDados()
                    }}
                    loading={loading === 'atualizando-dados'}
                    fullWidth={sttAuthCtx.isMobile}
                    sx={!sttAuthCtx.isMobile ? { width: '250px' } : {}}
                  >
                    Continuar
                  </ButtonLoading>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' className='tw-text-center'>
                    Ao criar uma conta, você concorda com todos os
                    <br />
                    <Link
                      href='https://agendeiquadras.com.br/termos.html'
                      underline='none'
                      target='_blank'
                    >
                      termos e políticas
                    </Link>
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}
        </>
      </div>
    </Modal>
  )

  function CompCidade({ city }) {
    return (
      <Box
        sx={{
          ...stModal.cardContainer,
          width: !sttAuthCtx.isMobile ? 'calc(100% - 20px)' : '100%',
        }}
        onClick={() => {
          AtualizarCidadeUser(city)
        }}
      >
        <Box sx={stModal.cityInfo}>
          <Typography variant='h6' sx={stModal.titleCidade}>
            {city.nomeCidade}
          </Typography>
          <Typography variant='body2' sx={stModal.subTitleCidade}>
            {city.estado.sigla}
          </Typography>
        </Box>
        <Box sx={stModal.iconAction}>
          <ArrowForwardIosIcon sx={stModal.iconActionIcon} />
        </Box>
      </Box>
    )
  }
}

const stModal = {
  containHeader: {
    height: 'auto',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    '.MuiCardHeader-avatar': {
      marginRight: '7px',
    },
  },
  titleModal: {
    height: 'auto',
    width: '100%',
    textAlign: 'left',
    fontSize: '1.5rem',
    fontFamily: 'jost-mediun',
  },
  subTitle: {
    height: 'auto',
    width: '100%',
    textAlign: 'left',
    fontSize: '17px',
    fontFamily: 'jost-light',
  },

  cardContainer: {
    borderRadius: '8px',
    backgroundColor: '#f7f7f7',
    marginBottom: '8px',
    padding: '8px 16px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    boxSizing: 'border-box',
  },
  cityInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  titleCidade: {
    fontWeight: 'bold',
    color: 'var(--color-text-hig)',
    fontSize: '18px',
    fontFamily: 'integral-cf-demibold',
  },
  subTitleCidade: {
    fontSize: '14px',
    color: '#9E9E9E',
    fontFamily: 'integral-cf-demibold',
  },
  iconAction: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  iconActionIcon: {
    color: '#FF5722',
    fontSize: '20px',
  },
}
